import { FeatureFlags } from './FeatureFlags';
import { IsAccountReadOnly } from './IsAccountReadOnly';
import { MaxHeight } from './MaxHeight';

export default {
  featureFlags: FeatureFlags,
  isAccountReadOnly: IsAccountReadOnly,
  maxHeight: MaxHeight,
};
